import { useQuery } from '@tanstack/react-query';

import { getConfig } from '@/shared/api';

export const useGetConfig = () => {
  return useQuery({
    queryKey: ['getConfig'],
    queryFn: async () => {
      const { data } = await getConfig();

      return data;
    },
  });
};
